import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Logout(props) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.01862 18.8034H12.0746C12.4467 18.8034 12.7474 19.1041 12.7474 19.4762C12.7474 19.8483 12.4467 20.1491 12.0746 20.1491H6.01862C4.90569 20.1491 4 19.2434 4 18.1305V6.01865C4 4.90572 4.90569 4 6.01862 4H12.0746C12.4467 4 12.7474 4.30083 12.7474 4.67293C12.7474 5.04502 12.4467 5.34579 12.0746 5.34579H6.01862C5.64722 5.34579 5.34576 5.64722 5.34576 6.01865V18.1305C5.34576 18.5019 5.64719 18.8034 6.01862 18.8034ZM15.9113 7.55798L20.0024 11.5953C20.1309 11.7224 20.2029 11.894 20.2029 12.0743C20.2029 12.2546 20.1302 12.4269 20.0024 12.5534L15.9113 16.5907C15.7807 16.7199 15.6098 16.7845 15.4389 16.7845C15.2653 16.7845 15.0917 16.7172 14.9598 16.5839C14.6994 16.3195 14.7015 15.8936 14.9666 15.6325L17.8902 12.7472H10.0559C9.68379 12.7472 9.38303 12.4464 9.38303 12.0743C9.38303 11.7022 9.68379 11.4015 10.0559 11.4015H17.8902L14.9666 8.51616C14.7014 8.25508 14.6988 7.82915 14.9598 7.56472C15.2209 7.30028 15.6475 7.29689 15.9113 7.55798Z"
        fill="black"
        fill-opacity="0.8"
      />
    </Svg>
  );
}

export default Logout;
